<script lang="ts">
	import { cn } from "#lib/web-ui/ui/utils.js";
	import { Section, SectionHeader, type SectionTheme } from "#lib/web-ui/primitives/index.js";

	interface HandlesColumn {
		title: string;
		items: string[];
	}

	interface Props {
		title: string;
		columns: HandlesColumn[];
		note: string;
		theme?: SectionTheme;
		id?: string;
	}

	let { title, columns, note, theme = "muted", id }: Props = $props();
</script>

<Section {theme} {id} data-testid="associate-handles">
	<SectionHeader {title} align="left" />

	<div class="divide-border grid gap-10 md:grid-cols-2 md:gap-0 md:divide-x">
		{#each columns as column, index (column.title)}
			<div class="md:px-10 md:first:pl-0 md:last:pr-0">
				<h3 class="text-foreground text-xl font-semibold">{column.title}</h3>
				<ul class="mt-4 space-y-3">
					{#each column.items as item (item)}
						<li class="text-muted-foreground flex gap-3 text-sm">
							<span
								aria-hidden="true"
								class={cn(
									"mt-2 h-0.5 w-3 flex-shrink-0",
									index === 0 ? "bg-primary" : "bg-muted-foreground"
								)}
							></span>
							{item}
						</li>
					{/each}
				</ul>
				{#if index === columns.length - 1}
					<p class="text-foreground mt-8 font-medium">{note}</p>
				{/if}
			</div>
		{/each}
	</div>
</Section>
